module.exports = "<div class=\"sn-header not-print\" ng-show=\"navbar && !$root.isContactForm\" style=\"height: auto\">\n    <div class=\"container\">\n        <user-navbar ng-if=\"navbar === 'authenticatedUser'\"></user-navbar>\n        <anonymous-navbar ng-if=\"navbar === 'anonymousUser'\"></anonymous-navbar>\n        <admin-navbar ng-if=\"navbar === 'adminUser'\"></admin-navbar>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/js/components/navigation/header/header.component.html
// module id = ./web/js/components/navigation/header/header.component.html
// module chunks = 0